import { AppError } from '../errors/app-error';

export class MyAccountNotGrantedError extends AppError {
  readonly missingScopes: readonly string[];

  constructor(missingScopes: readonly string[]) {
    super('forbidden', `Auth0 did not grant the My Account scopes: ${missingScopes.join(', ')}`, {
      status: 403,
      details: { missingScopes },
    });
    this.name = 'MyAccountNotGrantedError';
    this.missingScopes = missingScopes;
  }
}
